import { Module } from "wrapper6";

var $ = jQuery;

export default class Filters extends Module {

	ready(app) {

        /********************************************
		* SHARED VARS
		********************************************/
        const LOADER = $('#loader-overlay');
        
        /********************************************
        * 
        * TEACHING TOPICS FILTER
        * 
        ********************************************/

        // TT = Teaching Topics

        // Consts
        const TT_DEST = $('.posts-wrapper');
        const TT_PAGINATION = '#teaching-topics-pagination ul li a';
        const TT_PAGINATION_DEST = $('#teaching-topics-pagination');
        const TARGET_GROUP_SELECT = '#target-group-select';
        const PLACE_SELECT = '#place-select';
        const SUBJECT_SELECT = '#subject-select';

        // Lets
        let target_group_id = "";
        let tt_place = "";
        let tt_subject = "";
        let tt_page_number = 0;


          // filter target group mobile
          $(document).on('change', TARGET_GROUP_SELECT, function() {
            target_group_id = $(this).val();
            tt_place = $(PLACE_SELECT).val();
            tt_subject = $(SUBJECT_SELECT).val();
            tt_page_number = 0;

            getTeachingTopics();
            
        });

        // filter place
        $(document).on('change', PLACE_SELECT, function() {
            tt_place = $(this).val();
            tt_subject = $(SUBJECT_SELECT).val();
            tt_page_number = 0;

            getTeachingTopics();
            
        });


        // filter subject
        $(document).on('change', SUBJECT_SELECT, function() {
            tt_place = $(PLACE_SELECT).val();
            tt_subject = $(this).val();
            tt_page_number = 0;

            getTeachingTopics();
            
        });


        // filter pagination
        $(document).on('click', TT_PAGINATION, function(e) {
            // Prevent default link behavior
            e.preventDefault();
            
            tt_page_number = $(this).attr('data-page');            

            getTeachingTopics();
        });


        // Ajax request function
		function getTeachingTopics() {

			// Show loader
			LOADER.addClass('show');

			// Animate body to top
      $('html, body').animate({
          scrollTop: $('.posts-wrapper').offset().top - 150
      }, 500);

			// Set ajax data
			let data = {
                'action': 'filter_teaching_topics',
                'target_group': target_group_id,
                'place': tt_place,
                'subject': tt_subject,
				'page_number': tt_page_number,
				'url': window.location.href,
			};
			
			// Ajax call
			jQuery.post(main_theme_objects.ajax_url, data, function(response) {

				if (response != 0) {

                    if (response.posts === '') {
                        response.posts = '<p class="no-posts">Ingen indlæg fundet</p>';
                    }


					// Post response
                    TT_DEST.html(response.posts);

                    TT_DEST.append('<div class="filler"> </div>');
                    TT_DEST.append('<div class="filler"> </div>');
                    
					// Pagination response
					TT_PAGINATION_DEST.html(response.pagination);

					// Hide loader
					LOADER.removeClass('show');

				}
			});
		}



        /********************************************
		* TEACHING TOPICS  FILTER END
		********************************************/
        
    }
}